import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { strings } from '@constants'
import Switch from '../Switch'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import ProgressBar from '../ProgressBar'
import { getInputType } from '@base/composite/Table/TableUtils/Columns'
import { showDateFormat } from '@utils'

const ProgressBarWapper = styled.div`
	width: 100%;
`

const Spo = ({ RunningData, DelayedData, DelayedCount, RunningCount, OpenPurchaseCount }) => {
	const [status, setStatus] = useState('DELAY')
	const columns = useMemo(
		() => [
			{
				label: `${strings('pocd')}/${strings('order', 'date')}`,
				key: (itemData) => {
					return (
						<>
							<div>
								<b>{itemData?.po_completion_date ? showDateFormat(new Date(itemData?.po_completion_date)) : '-'}</b>
							</div>
							<div>
								<small>{itemData?.order_date ? showDateFormat(new Date(itemData?.order_date)) : '-'}</small>
							</div>
						</>
					)
				},
			},
			{
				label: strings('buyer'),
				key: 'buyer_name',
				mobile: true,
			},

			{
				label: strings('supplier'),
				key: 'supplier_name',
				mobile: true,
				align: 'center',
			},
			{
				label: `${strings('serviced')} vs ${strings('ordered')}`,
				key: (itemData) => {
					const servedPercent = Math.round((itemData?.serviced_weight / itemData?.ordered_weight) * 100)
					return (
						<ProgressBarWapper>
							<span>
								{itemData?.serviced_weight} / {itemData?.ordered_weight} {getInputType(itemData?.input_type)}
							</span>
							<ProgressBar fillColor={servedPercent} value={servedPercent} />
						</ProgressBarWapper>
					)
				},
				mobile: false,
				cellWidth: 25,
				align: 'right',
			},
		],

		[]
	)

	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>SPOs({OpenPurchaseCount})</Heading>
				<Switch
					options={[
						{ label: `Running(${RunningCount})`, value: 'RUN' },
						{ label: `Delayed(${DelayedCount})`, value: 'DELAY' },
					]}
					value={status}
					onChange={setStatus}
				/>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight
					data={status === 'RUN' ? RunningData : DelayedData}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					onRowClick={() => {}}
					hideFooter
					rowClickable={false}
				/>
			</TableContainer>
		</Wapper>
	)
}

export default Spo
